export default "__VITE_ASSET__CZDeaY6a__"